import { licenseAgreement, privacyPolicy } from '@constants/URLs';
import { Trans, useTranslation } from 'react-i18next';
import { StyledLegalContainer, StyledLegalDivider } from './styles';

export default function LegalPolicies() {
  const { t } = useTranslation('authentication');

  return (
    <>
      <StyledLegalContainer>
        <Trans
          i18nKey="legal.continueAndAgree"
          t={t}
          components={{
            privacyLink: (
              <a href={privacyPolicy} target="_blank" rel="noopener noreferrer">
                {t('legal.privacyPolicy')}
              </a>
            ),
            slaLink: (
              <a href={licenseAgreement} target="_blank" rel="noopener noreferrer">
                {t('legal.softwareLicenseAgreement')}
              </a>
            ),
          }}
        />
      </StyledLegalContainer>
      <StyledLegalDivider />
    </>
  );
}
